import { render, staticRenderFns } from "./SelectColumnsDialogContent.vue?vue&type=template&id=f04071d0&scoped=true&"
import script from "./SelectColumnsDialogContent.vue?vue&type=script&lang=js&"
export * from "./SelectColumnsDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./SelectColumnsDialogContent.vue?vue&type=style&index=0&id=f04071d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04071d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VList,VListItem,VListItemContent,VListItemGroup})
